export default class HelloBar {
    constructor() {
        this.bar = document.querySelector(".gb-container-923d0901");
        this.storageKey = "hello_bar_dismissed";
        this.init();
    }

    init() {
        if (!this.bar) return;
        this.checkState();
    }

    checkState() {
        if (sessionStorage.getItem(this.storageKey) === "true") {
            this.hide(false);
        } else {
            this.initStyles();
            this.addCloseButton();
            this.bindEvents();
        }
    }

    initStyles() {
        this.bar.style.overflow = "hidden";
    }

    addCloseButton() {
        const btn = document.createElement("button");
        btn.classList.add("hello-bar__close");
        btn.setAttribute("aria-label", "Dismiss notification bar");
        btn.innerHTML = "&times;";

        const gridContainer = this.bar.querySelector(".grid-container");
        const target = gridContainer || this.bar;
        target.appendChild(btn);

        this.closeBtn = btn;
    }

    bindEvents() {
        this.closeBtn.addEventListener("click", () => {
            sessionStorage.setItem(this.storageKey, "true");
            this.hide(true);
        });
    }

    hide(animate) {
        if (animate) {
            const styles = window.getComputedStyle(this.bar);
            const startHeight = this.bar.scrollHeight;
            const paddingTop = styles.paddingTop;
            const paddingBottom = styles.paddingBottom;

            this.bar.animate(
                [
                    { height: startHeight + "px", paddingTop, paddingBottom, opacity: 1 },
                    { height: "0px", paddingTop: "0px", paddingBottom: "0px", opacity: 0 },
                ],
                {
                    duration: 400,
                    easing: "ease",
                    fill: "forwards",
                }
            ).finished.then(() => {
                this.bar.style.display = "none";
            });
        } else {
            this.bar.style.display = "none";
        }
    }
}